import GlobalWrapper from "src/lib/globals/GlobalWrapper"
import React from "react"
import { LearnLine } from "src/lib/linear/learn_line/LearnLine"

export default function () {
  return (
    <GlobalWrapper>
      <LearnLine />
    </GlobalWrapper>
  )
}
